var map = {
	"./currency/route.js": "536e",
	"./daily-closeout-report/components/index.js": "54a6",
	"./daily-closeout-report/config/columns.js": "5078",
	"./daily-closeout-report/config/index.js": "ad08",
	"./daily-closeout-report/route.js": "a0b2",
	"./exchange-rate/route.js": "ba52",
	"./monthly-semester-mapping/router.js": "2f7a",
	"./router.js": "37f3",
	"./score-copy/router.js": "b472",
	"./student-transfer-module/components/index.js": "3d32",
	"./student-transfer-module/router.js": "313a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52f3";